const TEMPURL = "http://maplays.net:8181"
// const TEMPURL = "http://127.0.0.1:8181"
// const TEMPURL = "http://192.168.9.194:8180"

export default TEMPURL
